import { memo, useEffect, useMemo } from 'react';
import { Box, CssBaseline, Grid, IconButton } from '@mui/material';
import CustomCard from 'components/cmn/CustomCard';
import PageMainTitle from 'components/cmn/PageMainTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from 'store';
import isEmpty from 'lodash/isEmpty';
import { showMessage } from 'store/message/messageSlice';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useProject } from 'hooks/useProject';
import AccountProjectListTable from 'components/member-management/AccountProjectListTable';

function MemberProjectManagementPage(): JSX.Element {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { getCompBizAdminInfo } = useProject();
  const { data: adminInfo } = getCompBizAdminInfo(id || '');

  const adminInfoData = useMemo(() => {
    return adminInfo || {};
  }, [adminInfo]);

  useEffect(() => {
    if (isEmpty(id)) {
      dispatch(showMessage({ message: '부적절한 경로로 접근하였습니다. 다시 시도해주세요.', variant: 'warning' }));
      navigate('/admin/member-management');
    }
  }, [dispatch, id, navigate]);

  const handlePrev = () => {
    navigate('/admin/member-management');
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Grid container>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <IconButton onClick={handlePrev} sx={{ width: 32 }}>
            <ArrowBackIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <PageMainTitle title={`${adminInfoData?.name || id}님의 프로젝트 진행상황`} />
          <CustomCard sx={{ mt: 2 }} content={false} border>
            <AccountProjectListTable id={id || ''} type="admin" />
          </CustomCard>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(MemberProjectManagementPage);
